<template>
  <div class="content">
    <div class="user-section">
      <div class="user-info-box">
        <div class="info-box-left">
          <div class="portrait-box">
            <van-image
              class="portrait"
              round
              width="65"
              height="65"
              :src="userInfo.avatar || require('@/static/missing-face.png')"
            ></van-image>
          </div>
          <div class="info-box">
            <span class="username">{{ userInfo.nickname || "游客" }}</span>
            <!-- <div class="phone-number">{{ userInfo.phone | encryptPhone }}</div> -->
            <div class="phone-number" v-if="userInfo.memberLevel">
              会员等级：{{ userInfo.memberLevel.name }}
            </div>
            <div class="phone-number" v-else>会员等级：普通会员</div>
          </div>
        </div>
        <div class="info-box-right">
          <div @click="navTo('/pages/userinfo/userinfo')" class="edit-btn">
            编辑
          </div>
        </div>
      </div>
      <!-- <div class="vip-card-box">
      <van-image
          lazy-load
          class="card-bg"
          width="190"
          height="130"
          :src="require('@/static/vip-card-bg.png')"
          mode
        ></van-image>
             <div class="b-btn b-btn-width" @click="handleShare">立即分享</div>
             <div class="tit">
               <span class="yticon icon-iLinkapp-"></span>
               会员
             </div>
             <span class="e-m">QIAN TI VIP</span>
             <span class="e-b">分享成为会员，消费得积分</span>
      </div> -->
    </div>
    <div class="cover-container">
      <!-- @touchstart="coverTouchstart"
      @touchmove="coverTouchmove"
      @touchend="coverTouchend" -->
      <div class="tj-sction">
        <div class="tj-item" @click="navTo('/pages/balanceLog/balanceLog')">
          <span class="num">{{
            userInfo && userInfo.balance ? userInfo.balance : 0
          }}</span>
          <span>余额</span>
        </div>
        <!-- <div class="tj-item" @click="navTo('/pages/card/list')">
          <span class="num">{{
            userInfo && userInfo.shoppingCardBalance
              ? userInfo.shoppingCardBalance
              : 0
          }}</span>
          <span>购物卡</span>
        </div> -->
        <div class="tj-item" @click="navTo('/pages/couponList/couponList')">
          <span class="num">{{
            userInfo && userInfo.couponCount ? userInfo.couponCount : 0
          }}</span>
          <span>优惠券</span>
        </div>
        <div class="tj-item" @click="navTo('/pages/pointLog/pointLog')">
          <span class="num">{{
            userInfo && userInfo.integral ? userInfo.integral : 0
          }}</span>
          <span>积分</span>
        </div>
        <div
          class="tj-item"
          v-if="userInfo.type === 1"
          @click="navTo('/pages/user/MyCommission')"
        >
          <span class="num">{{
            userInfo && userInfo.commission ? userInfo.commission : 0
          }}</span>
          <span>佣金</span>
        </div>
      </div>
      <!-- 订单 -->
      <div class="order-section">
        <van-cell
          title="我的订单"
          is-link
          value="全部订单"
          :border="false"
          @click="navTo('/pages/order/order')"
        />
        <div class="section-bottom">
          <div
            class="order-item"
            @click="navTo('/pages/order/order?state=0')"
            hover-class="common-hover"
            :hover-stay-time="50"
          >
            <van-image :src="require('@/static/un-payment.png')"></van-image>
            <span>待付款</span>
            <div v-if="orderNum.prePayNum > 0" class="num">
              {{ orderNum.prePayNum > 99 ? "99+" : orderNum.prePayNum }}
            </div>
          </div>
          <div
            class="order-item"
            @click="navTo('/pages/order/order?state=4')"
            hover-class="common-hover"
            :hover-stay-time="50"
          >
            <van-image :src="require('@/static/un-payment.png')"></van-image>
            <span>待成团</span>
            <div v-if="orderNum.invitationNum > 0" class="num">
              {{ orderNum.invitationNum > 99 ? "99+" : orderNum.invitationNum }}
            </div>
          </div>
          <div
            class="order-item"
            @click="navTo('/pages/order/order?state=2')"
            hover-class="common-hover"
            :hover-stay-time="50"
          >
            <van-image :src="require('@/static/un-payment.png')"></van-image>
            <span>待发货</span>
            <div v-if="orderNum.preDeliveryNum > 0" class="num">
              {{
                orderNum.preDeliveryNum > 99 ? "99+" : orderNum.preDeliveryNum
              }}
            </div>
          </div>
          <div
            class="order-item"
            @click="navTo('/pages/order/order?state=3')"
            hover-class="common-hover"
            :hover-stay-time="50"
          >
            <van-image
              :src="require('@/static/wait-receiving.png')"
            ></van-image>
            <span>待收货</span>
            <div v-if="orderNum.preReceiptNum > 0" class="num">
              {{ orderNum.preReceiptNum > 99 ? "99+" : orderNum.preReceiptNum }}
            </div>
          </div>
          <div
            class="order-item"
            @click="navTo('/pages/order/order?state=5')"
            hover-class="common-hover"
            :hover-stay-time="50"
          >
            <van-image
              :src="require('@/static/afterSale-refund.png')"
            ></van-image>
            <span>售后/退货</span>
            <div v-if="orderNum.afterSaleNum > 0" class="num">
              {{ orderNum.afterSaleNum > 99 ? "99+" : orderNum.afterSaleNum }}
            </div>
          </div>
        </div>
      </div>
      <!-- 我的项目 -->
      <div class="obj-section">
        <!-- <van-cell
          title="我的音频订单"
          icon="description"
          is-link
          @click="navTo('/onlinePages/order/order?state=0')"
        /> -->
        <van-cell
          title="我的线上商品订单"
          icon="description"
          is-link
          @click="navTo('/onlinePages/order/virtualOrder?state=0')"
        />
        <van-cell
          title="我的收藏"
          icon="star-o"
          is-link
          @click="navTo('/pages/collect/list')"
        />
        <van-cell
          title="地址管理"
          icon="location-o"
          is-link
          @click="navTo('/pages/address/address')"
        />
        <van-cell
          :title="userInfo.isPwd === 0 ? '设置交易密码' : '修改交易密码'"
          icon="setting-o"
          is-link
          @click="editPwd"
        />
        <van-cell title="我的二维码" icon="qr-invalid" is-link @click="myqc" />
        <van-cell
          title="我的客户"
          icon="friends-o"
          is-link
          to="/pages/user/MyClient"
        />
        <van-cell
          title="领券中心"
          icon="coupon-o"
          is-link
          to="/pages/test/test"
        />
        <van-cell
          title="我的银行卡"
          icon="coupon-o"
          is-link
          to="/pages/user/bankCard"
        />
        <!-- <van-cell
          title="客服"
          icon="coupon-o"
          is-link
          url="https://openai.weixin.qq.com/webapp/hbJaYNvg5z8xlxLXaTzxURz8KOdLOB?robotName=%E7%9B%B4%E8%B5%8B%E7%A7%91%E6%8A%80"
        /> -->
      </div>
      <!-- 浏览历史 -->
      <div class="history-section icon">
        <div class="sec-header">
          <span class="yticon icon-lishijilu"></span>
          <span>浏览历史</span>
        </div>
        <div class="h-list">
          <div
            class="list-item"
            v-for="(item, index) in fookMarkList"
            :key="index"
            @click="
              navTo(
                `/pages/product/product?id=${item.productId}&type=${
                  item.type === 1 ? 3 : 1
                }`
              )
            "
          >
            <van-image
              lazy-load
              :src="item.picture"
              class="h-list-image"
            ></van-image>
            <div class="history-bottom">
              <div class="history-title">{{ item.name }}</div>
              <div class="history-two-title" v-if="item.promotionName">
                {{ item.promotionName }}
              </div>
              <div class="history-two-title" v-else>无</div>
              <div class="history-price">
                <div class="price">￥{{ item.price }}</div>
                <div class="lookNum">{{ item.scanNum }}人浏览</div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <!--      <div v-if="hasLogin" class="history-section list-cell log-out-btn" @click="toLogout">-->
      <!--        <span class="cell-tit">退出登录</span>-->
      <!--      </div>-->
    </div>
    <van-popup v-model="showQc">
      <!-- 二维码 -->
      <vue-qr
        :correctLevel="3"
        :autoColor="true"
        colorDark="#000"
        :logoSrc="userInfo.avatar"
        :text="QcCode"
        :size="255"
        :margin="10"
        :logoMargin="3"
      >
      </vue-qr>
    </van-popup>
  </div>
</template>
<script>
import listCell from "@/components/mix-list-cell";
import { mapState, mapMutations } from "vuex";
import vueQr from "vue-qr";
let startY = 0,
  moveY = 0,
  pageAtTop = true;
export default {
  components: {
    listCell,
    vueQr,
  },
  filters: {
    encryptPhone(phone) {
      let str2 = "";
      if (phone) {
        let str = phone.slice(3, 9);
        str2 = phone.replace(str, "******");
      }
      return str2;
    },
  },
  data() {
    return {
      coverTransform: "translateY(0px)",
      coverTransition: "0s",
      moving: false,
      fookMarkList: [],
      showQc: false,
      QcCode: "",
      orderNum: {
        preReceiptNum: 0, //待收货
        orderId: 0,
        afterSaleNum: 0, //售后
        userId: 0,
        preDeliveryNum: 0, //待发货
        prePayNum: 0, //待付款
      },
    };
  },
  created() {},
  mounted() {
    this.loadData();
  },
  onShareAppMessage() {
    return {
      title: "",
      desc: "",
      path: this.$uitl.thisPage().route,
      imageUrl: "",
    };
  },
  computed: {
    ...mapState(["hasLogin", "userInfo", "domain"]),
  },
  methods: {
    editPwd() {
      if (!this.userInfo.phone) return this.$toast("请先编辑手机号");
      if (this.userInfo.isPwd === 0) {
        this.$router.push("/pages/user/SetPassWord?set=1");
      } else {
        this.$router.push("/pages/user/SetPassWord");
      }
    },
    ...mapMutations(["logout", "login"]),
    loadData() {
      this.getFootMartList();
      this.getOrderNum();
      this.getUserInfo();
    },
    getUserInfo() {
      this.$http.request(this.$http.pathMap.userInfo, "post").then((res) => {
        if (res.data) {
          this.login(res.data);
          localStorage.setItem("userId", res.data.id);
        }
      });
    },
    getOrderNum() {
      this.$http
        .request(this.$http.pathMap.orderStatusNum, "get")
        .then((res) => {
          this.orderNum = res.data;
        });
    },
    getFootMartList() {
      this.$http
        .request(this.$http.pathMap.footMarkList, "get", {
          page: 1,
          size: 20,
        })
        .then((res) => {
          this.fookMarkList = res.data.list;
        });
    },
    /**
     * 统一跳转接口,拦截未登录路由
     * navigator标签现在默认没有转场动画，所以用div
     */
    navTo(url) {
      if (!this.hasLogin) {
        url = "/pages/public/login";
      }
      this.$router.push(url);
    },
    //退出登录
    toLogout() {
      this.$dialog
        .confirm({
          title: "提示",
          message: "确定要退出登录吗？",
        })
        .then((res) => {
          this.userLogout();
        });
    },
    userLogout() {
      this.logout();
      localStorage.removeItem("token");
      // setTimeout(() => {
      //   location.reload()
      // }, 500)
    },

    /**
     *  会员卡下拉和回弹
     *  1.关闭bounce避免ios端下拉冲突
     *  2.由于touchmove事件的缺陷（以前做小程序就遇到，比如20跳到40，h5反而好很多），下拉的时候会有掉帧的感觉
     *    transition设置0.1秒延迟，让css来过渡这段空窗期
     *  3.回弹效果可修改曲线值来调整效果，推荐一个好用的bezier生成工具 http://cubic-bezier.com/
     */
    coverTouchstart(e) {
      if (pageAtTop === false) {
        return;
      }
      this.coverTransition = "transform .1s linear";
      startY = e.touches[0].clientY;
    },
    coverTouchmove(e) {
      moveY = e.touches[0].clientY;
      let moveDistance = moveY - startY;
      if (moveDistance < 0) {
        this.moving = false;
        return;
      }
      e.preventDefault();
      this.moving = true;
      if (moveDistance >= 80 && moveDistance < 100) {
        moveDistance = 80;
      }

      if (moveDistance > 0 && moveDistance <= 80) {
        this.coverTransform = `translateY(${moveDistance}px)`;
      }
    },
    coverTouchend() {
      if (this.moving === false) {
        return;
      }
      this.moving = false;
      this.coverTransition = "transform 0.3s cubic-bezier(.21,1.93,.53,.64)";
      this.coverTransform = "translateY(0px)";
    },
    handleShare() {
      this.$weChatShare(onShareAppMessage);
    },
    myqc() {
      let flag = false;
      let userId = localStorage.getItem("userId");
      let domains = (window.location.href += "?y=0&userId=" + userId);
      if (this.userInfo.qrCode) {
        this.QcCode = domains;
        flag = true;
      } else {
        this.QcCode = domains;
        flag = true;
      }
      if (flag) {
        this.showQc = true;
      }
    },
  },
};
</script>
<style lang="scss" scoped>
%flex-center {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
}

%section {
  display: flex;
  justify-content: space-around;
  align-content: center;
  background: #fff;
  border-radius: 5px;
}
.content {
  background: #f5f5f5;
}
.user-section {
  position: relative;

  padding: 20px 15px;
  .user-info-box {
    height: 90px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-left: 20px;
    .info-box-left {
      display: flex;
      align-items: center;
      .portrait-box {
        .portrait {
          border: 2px solid #fff;
        }
      }
      .info-box {
        margin-left: 10px;
        .username {
          font-size: $uni-font-size-lg + 1px;
          color: #3d3d3d;
        }
        .phone-number {
          font-size: 14px;
          color: #999;
        }
      }
    }
    .info-box-right {
      .edit-btn {
        width: 56px;
        height: 25px;
        background: #496bcb;
        border-radius: 155px 155px 155px 155px;
        opacity: 1;
        color: #fff;
        line-height: 25px;
        text-align: center;
        font-size: 14px;
      }
    }
  }
}

.vip-card-box {
  display: flex;
  flex-direction: column;
  color: #f7d680;
  height: 120px;
  background: -webkit-gradient(
    linear,
    left top,
    right top,
    from(rgba(0, 0, 0, 0.7)),
    to(rgba(0, 0, 0, 0.8))
  );
  // background-color: rgba(0, 0, 0, 0.7);
  border-radius: 8px 8px 0 0;
  overflow: hidden;
  position: relative;
  padding: 10px 12px;

  .card-bg {
    position: absolute;
    top: 10px;
    right: 0;
    width: 190px;
    height: 130px;
  }

  .b-btn-width {
    width: 66px;
  }

  .b-btn {
    position: absolute;
    right: 10px;
    top: 8px;
    height: 20px;
    text-align: center;
    line-height: 20px;
    font-size: 11px;
    color: #36343c;
    border-radius: 20px;
    background: -webkit-gradient(
      linear,
      left top,
      right top,
      from(#f9e6af),
      to(#ffd465)
    );
    z-index: 1;
  }

  .tit {
    font-size: $uni-font-size-base + 1px;
    color: #f7d680;
    margin-bottom: 14px;

    .yticon {
      color: #f6e5a3;
      margin-right: 8px;
    }
  }

  .e-b {
    font-size: $uni-font-size-sm;
    color: #d8cba9;
    margin-top: 5px;
  }
}

.cover-container {
  background: $page-color-base;

  padding: 0 15px;
  position: relative;
  background: #f5f5f5;
  padding-bottom: 10px;

  .arc {
    position: absolute;
    left: 0;
    top: -17px;
    width: 100%;
    height: 18px;
  }
}

.tj-sction {
  @extend %section;

  .tj-item {
    @extend %flex-center;
    flex-direction: column;
    height: 70px;
    font-size: $uni-font-size-sm;
    color: #75787d;
  }

  .num {
    font-size: $uni-font-size-lg;
    color: $font-color-dark;
    margin-bottom: 4px;
  }
}

.order-section {
  margin-top: 10px;
  border-radius: 10px;
  padding: 14px 0;
  padding-top: 0;
  background: #fff;
  .van-cell {
    border-radius: 10px;
    padding-right: 10px !important;
  }
  .section-bottom {
    @extend %section;
    .order-item {
      @extend %flex-center;
      width: 60px;
      height: 60px;
      border-radius: 5px;
      font-size: $uni-font-size-sm;
      color: $font-color-dark;
      position: relative;

      .num {
        position: absolute;
        top: 0;
        right: 10px;
        height: 15px;
        min-width: 15px;
        display: flex;
        justify-content: center;
        align-items: center;
        border-radius: 25px;
        padding: 2px;
        color: white;
        font-size: $uni-font-size-sm;
        background-color: var(--theme-font-color);
      }
    }
    .yticon {
      font-size: 24px;
      margin-bottom: 9px;
      color: #fa436a;
    }

    .icon-shouhoutuikuan {
      font-size: 22px;
    }
  }
}

.history-section {
  margin-top: 10px;
  border-radius: 10px;

  .sec-header {
    display: flex;
    align-items: center;
    font-size: $uni-font-size-base;
    color: $font-color-dark;
    line-height: 20px;
    margin-left: 15px;

    .yticon {
      font-size: 22px;
      color: #5eba8f;
      margin-right: 8px;
      line-height: 20px;
    }
  }

  .h-list {
    padding: 14px 0;
    display: flex;
    flex-wrap: wrap;
    justify-content: space-between;
    .list-item {
      width: 48%;
      height: 250px;
      background: #ffffff;
      border-radius: 10px;
      overflow: hidden;
      opacity: 1;
      margin-bottom: 10px;
      .h-list-image {
        border-radius: 10px 10px 0 0;
        overflow: hidden;
        width: 100%;
        height: 174px;
      }
      .history-bottom {
        padding: 5px;
        .history-title {
          font-size: 14px;
          color: #333;
          white-space: nowrap;
          text-overflow: ellipsis;
          overflow: hidden;
        }
        .history-two-title {
          font-size: 10px;
          color: #999;
          white-space: nowrap;
          text-overflow: ellipsis;
          overflow: hidden;
        }
        .history-price {
          display: flex;
          justify-content: space-between;
          align-items: center;
          .price {
            color: #e43131;
          }
          .lookNum {
            font-size: 10px;
            color: #999;
          }
        }
      }
    }
  }
}

.obj-section {
  padding: 10px 0;
  margin-top: 10px;
  align-content: center;
  background: #fff;
  border-radius: 10px;
}
.list-cell {
  display: flex;
  align-items: baseline;
  padding: 10px $page-row-spacing;
  line-height: 25px;
  position: relative;
  background: #fff;
  justify-content: center;

  &.log-out-btn {
    margin-top: 20px;

    .cell-tit {
      color: var(--theme-font-color);
      text-align: center;
      margin-right: 0;
    }
  }

  .cell-tit {
    flex: 1;
    font-size: $uni-font-size-base + 1px;
    color: $font-color-dark;
    margin-right: 5px;
  }
}
</style>
